import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isActive"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template-activatable/src/index.tsx
import React from 'react';
import baseIcon, { navigationActivatableDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
var NavigationIconWalletPath = 'M20.0381 21.8703H2.94288C2.40237 21.8703 1.96192 21.4235 1.96192 20.873V12.7246C2.2719 12.8363 2.60249 12.8941 2.94288 12.8941H20.0381V21.8703ZM1.96192 9.90208V9.88812C1.96192 9.86318 1.96388 9.83725 1.96584 9.81032C2.00705 9.31065 2.49556 8.90473 3.05275 8.90473H5.92696L4.42119 10.8994H2.94288C2.68096 10.8994 2.43965 10.7967 2.24444 10.5932C2.06492 10.4167 1.96683 10.1803 1.96192 9.92203V9.90208ZM12.9585 2.86377L19.2003 7.30896L16.5047 10.8994H14.6977C14.6134 9.59888 13.5628 8.57261 12.262 8.57261C10.9613 8.57261 9.91162 9.59888 9.82628 10.8994H6.89419L12.9585 2.86377ZM22 6.86714L12.5465 0.13501L7.43274 6.91002H3.05275C1.47438 6.91002 0.138316 8.10984 0.0107907 9.64177C0.00294303 9.73552 0 9.82927 0 9.92203V20.873C0 22.5226 1.32037 23.865 2.94288 23.865H22V10.8994H18.9728L22 6.86714ZM15.6954 18.8753H17.6573V15.8832H15.6954V18.8753Z';
var NavigationIconWalletActivePath = 'M16 18.865H18V15.865H16V18.865ZM4.924 6.86501L2.311 10.252C2.077 10.554 2.036 10.963 2.204 11.305C2.373 11.648 2.721 11.865 3.103 11.865H22V23.865H3C1.343 23.865 0 22.522 0 20.865V9.88501C0 9.79201 0.00300016 9.69801 0.0110002 9.60401C0.141 8.06801 1.503 6.86501 3.112 6.86501H4.924ZM13.679 0.308912L20.86 5.33891C21.082 5.49391 21.231 5.73291 21.274 6.00091C21.317 6.26791 21.249 6.54191 21.086 6.75891L18.756 9.86291H14.982C14.893 8.56191 13.824 7.53591 12.5 7.53591C11.176 7.53591 10.107 8.56191 10.018 9.86291H5.16L12.493 0.360912C12.832 0.0909116 13.309 0.0499116 13.679 0.308912Z';
var NavigationIcon = baseIcon('NavigationIconWallet', {
  getPath: _ref => {
    var {
      isActive
    } = _ref;
    return isActive ? NavigationIconWalletActivePath : NavigationIconWalletPath;
  },
  styleSheetPropsGetter: (_ref2, designVersion) => {
    var {
      isActive,
      color,
      colorToken,
      colorTokenArgs
    } = _ref2;
    return {
      isActive,
      color,
      designVersion,
      colorToken,
      colorTokenArgs
    };
  },
  defaultStyleSheetGetter: navigationActivatableDefaultStyleSheetGetter,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  restOfPropsSanitizer: _ref3 => {
    var {
        isActive
      } = _ref3,
      restOfProps = _objectWithoutProperties(_ref3, _excluded);
    return restOfProps;
  },
  groupProps: _objectSpread(_objectSpread({}, defaultNavigationIconGroupProps), {}, {
    x: 4,
    y: 2
  }),
  shapeSize: defaultNavigationIconShapeSize
});
var NavigationIconWallet = props => {
  useDeprecationWarning({
    componentName: 'NavigationIconWallet',
    removalDate: 'v6.0.0'
  });
  return /*#__PURE__*/React.createElement(NavigationIcon, props);
};
NavigationIconWallet.displayName = 'NavigationIconWallet';
export default NavigationIconWallet;
//# sourceMappingURL=index.js.map